export const CLOSE_EVENT_NAME = 'elsa_close_popover';

export default () => {
  const event = new Event(CLOSE_EVENT_NAME);
  document.dispatchEvent(event);
}
